var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import Slider from 'react-slick';
import { CarouselContainer, CustomNextArrow, CustomPrevArrow } from './carousel-styles';
// eslint-disable-next-line react/display-name
var Carousel = forwardRef(function (_a, ref) {
    var children = _a.children, arrows = _a.arrows, prevArrow = _a.prevArrow, nextArrow = _a.nextArrow, restProps = __rest(_a, ["children", "arrows", "prevArrow", "nextArrow"]);
    var _showArrows = arrows !== null && arrows !== undefined ? arrows : true;
    return (React.createElement(CarouselContainer, { showArrows: _showArrows },
        React.createElement(Slider, __assign({ ref: ref, arrows: _showArrows, prevArrow: prevArrow || React.createElement(CustomPrevArrow, null), nextArrow: nextArrow || React.createElement(CustomNextArrow, null) }, restProps), children)));
});
export default Carousel;
